<div class="row" (click)="onCustomTap($event)">
  <div class="col-10">
    @if (title()) {
      <div [class]="options().titleClass" [attr.aria-label]="title()" class="custom-title">{{ title() }}</div>
    }
    @if (message() && options().enableHtml) {
      <div
        role="alert"
        aria-live="polite"
        class="custom-message"
        [class]="options().messageClass"
      [innerHTML]="sanitized_message"></div>
    }
    @if (message() && !options().enableHtml) {
      <div
        role="alert"
        aria-live="polite"
        class="custom-message"
        [class]="options().messageClass"
        [attr.aria-label]="message()">
        {{ message() }}
      </div>
    }
  </div>
  <div class="col-2 text-end">
    @if (options().closeButton) {
      <a (click)="remove()" class="btn btn-sm toast-close-button">
        <svg-icon src="assets/images/common/svg/cross.svg" [svgClass]="'st-svg-14'"></svg-icon>
      </a>
    }
  </div>
</div>
@if (options().progressBar) {
  <div>
    <div class="toast-progress" [style.width]="width() + '%'"></div>
  </div>
}
